import React from 'react';
import { CardTheme } from '../card/index.jsx';
import { Row, Col, Divider, Collapse, Spin } from 'antd';
import { TextSmall, TextInputLabel } from '../text/index.jsx';

export const CardListComponent = ({ columns, dataSource, locale, expandable, loading }) => {
  // เช็คว่างต้องอยู่นอก map: ของเดิมอยู่ข้างในเลยไม่มีวันทำงาน ลิสต์ว่างจึงไม่ขึ้นอะไรเลย
  if (!dataSource || dataSource.length === 0) {
    // ระหว่างโหลดยังไม่รู้ว่ามีข้อมูลไหม ห้ามบอกว่าไม่พบ ไม่งั้นจะขึ้นผิดทุกครั้งที่เปิดหน้า
    if (loading) {
      return (
        <Col span={24} style={{ textAlign: 'center' }}>
          <Spin />
        </Col>
      );
    }

    return (
      <Col span={24}>
        <TextInputLabel style={{ textAlign: 'center' }}>
          {locale?.emptyText ? locale?.emptyText : `ไม่พบข้อมูล`}
        </TextInputLabel>
      </Col>
    );
  }

  return dataSource.map((record, index) => {
    const canExpand =
      expandable?.expandedRowRender &&
      (!expandable?.rowExpandable || expandable.rowExpandable(record));

    return (
      <CardTheme>
        <Row gutter={[0, 16]}>{columns.map((column) => renderCard(column, record, index))}</Row>
        {canExpand && (
          <Collapse
            ghost
            destroyInactivePanel={false}
            items={[
              {
                key: 'expand',
                label: 'ดูเพิ่มเติม',
                children: expandable.expandedRowRender(record, index),
              },
            ]}
          />
        )}
      </CardTheme>
    );
  });
};

const renderCard = (column, record, index) => {
  const dataIndex = column.dataIndex;
  const data = record[dataIndex];
  if (column.dataIndex == 'rowNum') {
    return (
      <Col span={24}>
        <TextInputLabel style={{ margin: '0px' }} bold>{`รายการที่ ${column.render(
          data,
          record,
          index,
        )}`}</TextInputLabel>
        <Divider style={{ margin: 0 }} />
      </Col>
    );
  }

  if (column?.children?.length > 0) {
    return (
      <>
        <Col span={24}>
          <TextSmall style={{ margin: '0px', textDecoration: 'underline' }} bold>
            {column.title}
          </TextSmall>
        </Col>
        {column.children.map((children) => renderCard(children, record, index))}
      </>
    );
  }

  return (
    <>
      <Col span={24}>
        <Row>
          {column.title && (
            <Col span={column?.cardProps?.titleSpan || 12}>
              <TextSmall style={{ margin: '0px' }} bold>
                {column.title}
              </TextSmall>
            </Col>
          )}
          <Col span={column?.cardProps?.dataSpan}>
            <TextInputLabel style={{ margin: '0px', ...column?.cardProps?.textStyle }}>
              <div style={{ marginLeft: column.dataSpan !== 24 ? '20px' : '0px' }}>
                {column.render ? column.render(data, record, index) : data}
              </div>
            </TextInputLabel>
          </Col>
        </Row>
      </Col>
    </>
  );
};
